export default __webpack_public_path__ + "static/media/Etape-9_MANUFACTURE_DEF.eb1f1faf.mp3";